var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskIconDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30859",
    "data-name": "Group 30859",
    transform: "translate(-1693 806)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8661",
    "data-name": "Rectangle 8661",
    transform: "translate(1693 -802)",
    fill: "none",
    stroke: "#f8f8f8",
    opacity: 0.5,
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 16,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 18.5,
    height: 14.5,
    rx: 1.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8662",
    "data-name": "Rectangle 8662",
    width: 10,
    height: 2,
    rx: 1,
    transform: "translate(1698 -806)",
    fill: "#f8f8f8",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21014",
    "data-name": "Path 21014",
    d: "M1698-798.639l2.5,2.791,5.5-6",
    transform: "translate(1 4.849)",
    fill: "none",
    stroke: "#f8f8f8",
    opacity: 0.5,
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskIconDark);
export default __webpack_public_path__ + "static/media/task-icon-dark.b56afba2bab4651f8a81b531f21156e9.svg";
export { ForwardRef as ReactComponent };